import { CustomSplitter, ConversationHoc } from 'components/shared';
import conversationSvg from 'assets/img/folder_preview.svg';
//'assets/img/conversation.svg';
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import utils, { SORT_VALUES } from 'utils';
import 'components/pages/folders-page/folders.scss';
import { InterventionListHoc } from 'components/pages';
import { FolderInterventionFilter } from 'components/pages/folders-page/folder-intervention-filter';
import { Badge } from "components/shared";
import { FlapHeader } from 'components/layout';


export const FoldersView = () => {

    const [data, setData] = useState();
    const history = useHistory();
    const folderDescription = new URLSearchParams(history.location.search).get('folder-item');
    const folderId = new URLSearchParams(history.location.search).get('folder-id');
    const [targetTask, setTargetTask] = useState(JSON.parse(new URLSearchParams(history.location.search).get('task')));

    useEffect(() => {
        setTargetTask(JSON.parse(new URLSearchParams(history.location.search).get('task')));
    }, [history.location.search]);

    return (
        <CustomSplitter
            splitSize={{ left: 40, size: 60 }}
            leftContent={
                <div style={{ height: '100vh', position: 'relative' }}>
                    <FlapHeader
                        primary
                        justify
                        leftSide={
                            <span className="py-2" style={{ fontSize: "14px" }}>
                                {`Agent - ${folderDescription ? folderDescription : ""}`} {data?.interventions.length > 0 && ` (${data.interventions.length}+)`}
                            </span>}
                        rightSide={
                            <div className="d-flex">

                                {data && <span className="py-2 d-flex">
                                    <ItemsSortingToggle />
                                    <Badge servirity="secondary" data={`Total Items ${data?.totalElements}`} />
                                </span>}
                            </div>
                        } />

                    <FolderInterventionFilter />
                    <InterventionListHoc folderId={folderId} callbackFn={(data) => setData({ totalElements: data.totalElements, interventions: data.interventions })} />
                </div>
            }
            rightContent={
                <div className="w-100">
                    {
                        targetTask?.interventionId ?
                            <ConversationHoc task={targetTask} folderView />
                            : utils.ImagePreviewContainer(conversationSvg)
                    }
                </div>}
        />
    );
}

const ItemsSortingToggle = () => {
    const [labelOn, setLabelOn] = useState(SORT_VALUES.DESCENDANT.label);
    const history = useHistory();
    const sortBy = useRef(SORT_VALUES.DESCENDANT.value);

    const ascSort = () => {
        return sortBy.current === SORT_VALUES.ASECENDANT.value;
    }

    const editSortParams = () => {
        setLabelOn(ascSort() ? SORT_VALUES.DESCENDANT.label : SORT_VALUES.ASECENDANT.label);
        sortBy.current = ascSort() ? SORT_VALUES.DESCENDANT.value : SORT_VALUES.ASECENDANT.value
    }

    const toggleEvent = () => {
        Promise.resolve(editSortParams()).then(() => {
            const queryParams = new URLSearchParams(history.location.search);
            queryParams.set("sort-by", sortBy.current);
            history.push({ search: queryParams.toString() });
        });
    }

    return <small className="mr-3" onClick={toggleEvent}
        style={{ cursor: "pointer" }}>
        <i className={`bi bi-${ascSort() ? "sort-numeric-up-alt" : "sort-numeric-down-alt"}`} /> {labelOn}
    </small>
}